export const providerKey = 'app-dialog'
